import { PALLETTE } from "../theme";

export function extractToothConditions(data: any): {} {
  const result = {};

  for (const key in data) {
    const value = data[key];

    // Only process keys where value is "Y"
    if (value === "Y") {
      // Match pattern like Q3__d_D
      const match = key.match(/^(Q\d)__([a-zA-Z])_([A-Z])$/);

      if (match) {
        const quadrant = match[1]; // e.g., Q3
        const label = match[2]; // e.g., d
        const condition = match[3]; // e.g., D
        const finalKey = `${quadrant}_${label}`;

        result[finalKey] = condition;
      }
    }
  }

  return result;
}

export function getStatusStyles(status: string): {
  backgroundColor: string;
  color: string;
} {
  switch (status) {
    case "Normal":
      return {
        backgroundColor: PALLETTE.greenShade1,
        color: PALLETTE.green,
      };

    case "Need Attention":
      return {
        backgroundColor: PALLETTE.yellowShade1,
        color: PALLETTE.yellow,
      };

    default:
      return {
        backgroundColor: PALLETTE.greenShade1,
        color: PALLETTE.green,
      };
  }
}

export const DmflabelMap: Record<string, string> = {
  D: "Decayed",
  M: "Missing",
  F: "Filled",
};

export const paths: Record<string, string> = {
  P8: "M8.97422 190.331C17.3462 192.843 35.1364 192.192 39.3227 190.331C48.7415 186.145 47.6947 170.447 41.4154 164.169C35.1361 157.89 17.3457 155.796 6.88075 162.075C-3.58425 168.354 -1.49077 187.192 8.97422 190.331Z",
  P7: "M21.5317 157.89C10.0202 157.89 4.78775 152.658 3.74125 149.518C1.64825 145.332 -0.444236 128.588 13.1603 126.495C26.7647 124.402 35.1362 130.681 39.3222 134.867C43.5082 139.053 46.6477 147.425 43.5082 152.658C40.3687 157.89 33.0432 157.89 21.5317 157.89Z",
  P6: "M24.7114 125.33C9.79216 122.418 7.92725 110.77 7.92725 104.945C9.79216 88.4432 24.7114 89.4139 32.1711 93.2967C39.6307 97.1796 45.2255 103.975 47.0904 110.77C48.9553 117.565 46.1579 122.418 43.3606 124.36C40.5632 126.301 35.9009 127.514 24.7114 125.33Z",
  P5: "M23.6247 75.2165C26.2731 70.5821 30.9504 68.9374 35.1364 68.9374C39.3224 68.9374 42.4617 69.9843 51.8802 75.2165C59.4152 79.4024 56.0664 93.0068 50.8339 97.1928C45.6014 101.379 33.6898 93.813 28.8572 90.9138C23.6244 87.7744 19.4385 82.5419 23.6247 75.2165Z",
  P4: "M44.5556 71.0303C35.1371 65.7978 34.0906 60.5653 37.2301 56.3793C38.4463 54.7577 40.0649 53.1425 44.5556 51.1468C53.9741 46.961 63.3917 56.3791 65.4848 58.4722L65.4848 58.4723C68.2749 61.2625 67.5778 67.8908 64.4383 73.1233C61.2988 78.3558 53.9741 76.2628 44.5556 71.0303Z",
  P3: "M75.9494 38.589C73.8564 31.2635 68.6239 28.124 64.4379 28.124C59.2056 28.124 51.8799 32.31 49.7869 38.589C47.6939 44.868 53.9729 49.0539 59.2054 53.2399C64.4379 57.4259 70.7169 60.5654 74.9029 57.4259C79.0889 54.2864 78.0424 45.9144 75.9494 38.589Z",
  P2: "M85.507 9.73072C81.0299 10.7803 74.3134 14.9786 72.0756 18.1272C67.5985 24.4244 75.4335 35.9696 77.672 39.1183C79.9106 42.267 88.8648 44.3661 94.4612 41.2174C100.058 38.0687 101.177 29.6722 98.9383 19.1767C96.6998 8.68117 89.9841 8.68117 85.507 9.73072Z",
  P1: "M106.979 33.2479C103.649 29.2503 99.2094 15.2585 98.0995 10.2615C97.2171 6.85169 99.2094 3.26561 115.859 1.26678C132.509 -0.732037 131.399 6.26384 131.399 10.2615C131.399 14.2591 128.069 26.2521 123.629 32.2485C119.189 38.245 110.309 37.2456 106.979 33.2479Z",
  "D-E1":
    "M75.9364 114.984C72.7969 112.891 65.4714 108.705 61.2854 105.565C57.0994 102.426 66.5177 91.9606 73.8425 96.1463C82.4623 101.072 83.2617 105.565 83.2617 108.704C83.2617 112.89 79.0759 117.077 75.9364 114.984Z",
  "D-D1":
    "M86.4011 85.6816C78.5854 81.2144 76.7533 81.7274 72.7971 85.6816C68.6088 90.9142 71.7487 93.007 78.0277 99.286C84.3067 105.565 87.754 101.073 88.4937 100.333C90.5853 98.2395 93.7252 89.8679 86.4011 85.6816Z",
  "D-C1":
    "M91.6342 68.9377C86.4017 67.8912 82.2157 72.0772 80.1227 74.1702C76.9832 79.4027 83.2622 83.5885 87.4482 86.728C91.6342 89.8675 95.8202 87.7745 97.9132 83.5885C100.006 79.4025 96.8667 69.9842 91.6342 68.9377Z",
  "D-B1":
    "M104.19 56.3806C102.096 57.4275 97.9112 59.5201 95.8194 62.6588C92.6799 66.5335 96.866 75.2167 100.006 77.3097C103.145 79.4027 105.238 79.4027 108.378 78.3562C111.517 77.3097 112.564 71.0305 111.517 62.6585C110.471 54.2865 106.719 55.1157 104.191 56.3797L104.19 56.3806Z",
  "D-A1":
    "M130.355 57.4261C130.355 53.2401 126.169 52.1936 120.936 52.1936C118.844 52.1287 113.611 52.1936 112.564 55.3331C111.518 58.4726 113.611 69.9841 115.704 73.1236C117.797 76.2631 121.983 76.2631 125.122 74.1701C128.262 72.0771 130.355 61.6121 130.355 57.4261Z",
  "D-A2":
    "M133.333 56.3896C133.471 52.2058 137.689 51.2981 142.919 51.4709C145.013 51.4751 150.24 51.7128 151.183 54.8852C152.125 58.0575 149.653 69.4936 147.457 72.5623C145.262 75.6309 141.078 75.4927 138.009 73.2972C134.941 71.1017 133.195 60.5733 133.333 56.3896Z",
  "D-B2":
    "M159.518 56.2083C161.575 57.3237 165.689 59.5534 167.676 62.7595C170.686 66.7357 166.215 75.276 163.008 77.2642C159.801 79.2523 157.709 79.1832 154.606 78.0336C151.503 76.884 150.664 70.5737 151.986 62.2408C153.309 53.9079 157.031 54.8606 159.516 56.2073L159.518 56.2083Z",
  "D-C2":
    "M171.653 69.1731C176.917 68.3 180.962 72.6219 182.985 74.7829C185.95 80.1162 179.536 84.0924 175.249 87.092C170.962 90.0915 166.847 87.8615 164.893 83.6086C162.94 79.3558 166.389 70.0463 171.653 69.1731Z",
  "D-D2":
    "M176.331 86.0807C184.29 81.8739 186.104 82.4471 189.927 86.5299C193.94 91.8979 190.733 93.8858 184.25 99.9541C177.767 106.022 174.47 101.419 173.755 100.655C171.734 98.4935 168.872 90.0228 176.331 86.0807Z",
  "D-E2":
    "M185.661 115.635C188.901 113.701 196.426 109.886 200.764 106.959C205.101 104.032 196.216 93.1106 188.692 96.9256C179.837 101.415 178.815 105.863 178.658 108.998C178.449 113.179 182.421 117.569 185.661 115.635Z",
  "P1-2":
    "M155.849 33.2479C159.179 29.2503 163.619 15.2585 164.729 10.2615C165.611 6.85169 163.619 3.26561 146.969 1.26678C130.32 -0.732037 131.429 6.26384 131.429 10.2615C131.429 14.2591 134.759 26.2521 139.199 32.2485C143.639 38.245 152.519 37.2456 155.849 33.2479Z",
  "P2-2":
    "M177.321 9.73072C181.798 10.7803 188.515 14.9786 190.752 18.1272C195.23 24.4244 187.395 35.9696 185.156 39.1183C182.918 42.267 173.963 44.3661 168.367 41.2174C162.771 38.0687 161.651 29.6722 163.89 19.1767C166.128 8.68117 172.844 8.68117 177.321 9.73072Z",
  "P3-2":
    "M186.878 38.589C188.971 31.2635 194.203 28.124 198.389 28.124C203.622 28.124 210.947 32.31 213.04 38.589C215.133 44.868 208.854 49.0539 203.622 53.2399C198.389 57.4259 192.11 60.5654 187.924 57.4259C183.738 54.2864 184.785 45.9144 186.878 38.589Z",
  "P4-2":
    "M218.273 71.0303C227.691 65.7978 228.738 60.5653 225.598 56.3793C224.382 54.7577 222.763 53.1425 218.273 51.1468C208.854 46.961 199.437 56.3791 197.344 58.4722L197.344 58.4723C194.553 61.2625 195.251 67.8908 198.39 73.1233C201.53 78.3558 208.854 76.2628 218.273 71.0303Z",
  "P5-2":
    "M239.204 75.2165C236.555 70.5821 231.878 68.9374 227.692 68.9374C223.506 68.9374 220.367 69.9843 210.948 75.2165C203.413 79.4024 206.762 93.0068 211.994 97.1928C217.227 101.379 229.139 93.813 233.971 90.9138C239.204 87.7744 243.39 82.5419 239.204 75.2165Z",
  "P6-2":
    "M238.117 125.33C253.036 122.418 254.901 110.77 254.901 104.945C253.036 88.4432 238.117 89.4139 230.657 93.2967C223.198 97.1796 217.603 103.975 215.738 110.77C213.873 117.565 216.67 122.418 219.468 124.36C222.265 126.301 226.927 127.514 238.117 125.33Z",
  "P7-2":
    "M241.297 157.89C252.808 157.89 258.041 152.658 259.087 149.518C261.18 145.332 263.273 128.588 249.668 126.495C236.064 124.402 227.692 130.681 223.506 134.867C219.32 139.053 216.181 147.425 219.32 152.658C222.46 157.89 229.785 157.89 241.297 157.89Z",
  "P8-2":
    "M252.423 190.331C244.051 192.843 226.261 192.192 222.075 190.331C212.656 186.145 213.703 170.447 219.982 164.169C226.261 157.89 244.051 155.796 254.516 162.075C264.981 168.354 262.888 187.192 252.423 190.331Z",
};
